const comment = {
	attrs: { id: { default: null } },
	inclusive: false,
};

export default comment;
